/** YYYY-MM-DD in local time — avoids UTC day shifts from `toISOString()`. */
export function formatLocalIsoDate(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function localIsoDateFromInstant(iso: string): string {
  return formatLocalIsoDate(new Date(iso))
}

export function getWeekRange(weekOffset = 0): { start: Date; end: Date; label: string } {
  const now = new Date()
  const day = now.getDay()
  const mondayOffset = day === 0 ? -6 : 1 - day

  const start = new Date(now)
  start.setHours(0, 0, 0, 0)
  start.setDate(start.getDate() + mondayOffset + weekOffset * 7)

  const end = new Date(start)
  end.setDate(end.getDate() + 6)
  end.setHours(23, 59, 59, 999)

  const label = `${start.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })} – ${end.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })}`

  return { start, end, label }
}

export function isInWeek(isoDate: string, weekOffset = 0): boolean {
  const { start, end } = getWeekRange(weekOffset)
  const d = new Date(isoDate)
  return d >= start && d <= end
}
